export default "\r\n<router-outlet></router-outlet>\r\n"